module.exports = __webpack_public_path__ + "img/40_38_068_700.be3f020e.jpg";